import styled from '@emotion/styled';

export const SpacingWrapper = styled.div`
  padding: 4rem 0;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    padding: 4.5rem 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 5rem 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 6rem 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 7.5rem 0;
  }
`;
